import { render, staticRenderFns } from "./magic-link.vue?vue&type=template&id=02f08a4d&"
import script from "./magic-link.vue?vue&type=script&lang=js&"
export * from "./magic-link.vue?vue&type=script&lang=js&"
import style0 from "./magic-link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports